export default {"src":"/_next/static/media/gewichtheffen.79725016.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};